/* unplugin-vue-components disabled */import { render } from "./KilaKilaCover.vue?vue&type=template&id=27a900ed&scoped=true"
import script from "./KilaKilaCover.vue?vue&type=script&lang=js"
export * from "./KilaKilaCover.vue?vue&type=script&lang=js"

import "./KilaKilaCover.vue?vue&type=style&index=0&id=27a900ed&scoped=true&lang=css"

import exportComponent from "E:\\Jweb\\结课作业\\KilaKila-Blog\\kilakila-frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27a900ed"]])

export default __exports__